
/*=======================================================================================
NOTE: Auto Generated File
=========================================================================================
Date:       2021-06-18 17:26:07.490
From:       BADGER\SQL2016 - qmuzik_metabase
Comment:    Any manual changes to this file will be overwritten. Move it to the relevant 
			"Custom" directory of the Angular project should you need to maintain your
			own version.
=========================================================================================*/

import { ModelStateValidation, ModelBase, AppGlobal } from "qmuzik-angular-model-core";
import { EISTaskSecurity } from "qmuzik-angular-model";
import { ModelStateValidationBase } from "qmuzik-angular-base";
import { Injectable } from "@angular/core";
import * as ts from "typescript";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Rules, Rule, SystemHooks } from "qmuzik-angular-model-core";
import { ValidationError } from "qmuzik-angular-model-core";
import { resolve } from "url";
import { NotificationService, InitialisationService } from "qmuzik-angular-service";

import { EISTaskSecurityService } from "../../service/generated/eistasksecurity.service";

import * as compiledRules from '../../rules/generated/eistasksecurity.rule';


@Injectable()
export class EISTaskSecurityModelStateValidation extends ModelStateValidationBase implements ModelStateValidation{
   
    constructor(
			private eISTaskSecurityService: EISTaskSecurityService,
			notificationService: NotificationService,
            initialisationService: InitialisationService,
			appGlobal: AppGlobal
        ) 
    { 
        super(notificationService, initialisationService, appGlobal); 
        
        this.modelStateType = EISTaskSecurity;
		this.modelStateTypeName = "EISTaskSecurity";
        this.modelStateValidatorName = "EISTaskSecurity";

        //note: to make services available to the validator we must inject it (constructor does not work, maybe because it is never used it is never injected)
		//		keep this example below, so that you know how you will gain access to any service from within your rule scripts e.g. validator.utilityService...
        //this.utilityService = AppInjector.get(UtilityService);
    }

    //note: get transpiled rules, if we are in production build
	//		this is called from the base class in production build
	//		you can import and add your own additional transpiled rules here
    GetRules(){
		this.rules = compiledRules.BuildRules(true, false);
    }          

    //note: every foreign key presents itself as a typeahead
    //everytime someone types in it this search function will be called
    //generated: this is auto-generated from foreign key metadata
    Search(source: string, typedValue: string, serializationLevel?: number){
		//note: if it wasn't passed, we'll use the decorator value
		if((serializationLevel === undefined) || (serializationLevel === null)){
			this.serializationLevel = Reflect.getMetadata("SerializationLevel", this.modelStateType);
			if((this.serializationLevel === undefined) || (this.serializationLevel === null)){
			  this.serializationLevel = 0;
			}
		}
		else
		{
			this.serializationLevel = serializationLevel;
		}
		       
		if(source == "HeaderControl"){
			return this.Get_HeaderControl(typedValue).pipe(map((data: any[]) => {
				return data;
				})
			)
		};  	   
	     

		if(source == "RefProfile"){
			return this.Get_RefProfile(typedValue).pipe(map((data: any[]) => {
				return data;
				})
			)
		};

		if(source == "RefEISTasks"){
			return this.Get_RefEISTasks(typedValue).pipe(map((data: any[]) => {
				return data;
				})
			)
		};

                        
        return null;
    }

    //note: business rules will also determine how typeaheads are populated
    //therefore all code calling for entity data should flow through here
    //generated: this is auto generated from foreign key metadata
	Get_HeaderControl(typedValue: string){
		//note: build the search properties filter 
		let searchProperties: string[] = [];
		this.searchFilter = [];
		searchProperties = Reflect.getMetadata("DefaultSearchProperties", this.modelState);

		for(var i = 0; i < searchProperties.length; i++){
			this.searchFilter.push(this.eISTaskSecurityService.CreateForFilter());
		}

		this.BuildFilter(searchProperties, typedValue);

		return this.eISTaskSecurityService.Search(this.searchFilter, this.advancedFilter["HeaderControlFilter"], this.staticFilter["Static"], this.instance, this.modelState as EISTaskSecurity, this.serializationLevel, this.viewInternalName, false, this.component.viewState);
	}


	Get_RefProfile(typedValue: string){
		//note: build the search properties filter 
		let searchProperties: string[] = [];
		this.searchFilter = [];
		searchProperties = Reflect.getMetadata("SearchProperties", this.modelState, "RefProfile");

		for(var i = 0; i < searchProperties.length; i++){
			this.searchFilter.push(this.eISTaskSecurityService.CreateForFilterRefProfile());
		}

		this.BuildFilter(searchProperties, typedValue);

		return this.eISTaskSecurityService.Get_EISTaskSecurity_RefProfile(this.searchFilter, this.advancedFilter["RefProfileFilter"], this.modelState as EISTaskSecurity, this.component.viewState);
	}

	Get_RefEISTasks(typedValue: string){
		//note: build the search properties filter 
		let searchProperties: string[] = [];
		this.searchFilter = [];
		searchProperties = Reflect.getMetadata("SearchProperties", this.modelState, "RefEISTasks");

		for(var i = 0; i < searchProperties.length; i++){
			this.searchFilter.push(this.eISTaskSecurityService.CreateForFilterRefEISTasks());
		}

		this.BuildFilter(searchProperties, typedValue);

		return this.eISTaskSecurityService.Get_EISTaskSecurity_RefEISTasks(this.searchFilter, this.advancedFilter["RefEISTasksFilter"], this.modelState as EISTaskSecurity, this.component.viewState);
	}

}
 
